const firebaseConfig = {
    apiKey: "AIzaSyABscV92VpCYK8vPgfyMWopju3zZ51C05g",
    authDomain: "carame-cake-website.firebaseapp.com",
    projectId: "carame-cake-website",
    storageBucket: "carame-cake-website.appspot.com",
    messagingSenderId: "367592244821",
    appId: "1:367592244821:web:903da900182e8cb95af6dc"
  };
  export default firebaseConfig;